import { colors, gradients } from '@airwallex/global';
export var navTheme = {
  background: colors.greys[100],
  item: {
    color: colors.greys[30],
    hover: {
      color: colors.white
    },
    selected: {
      gradient: 'orange'
    },
    tag: {
      background: "rgba(255, 255, 255, .15)",
      color: colors.white,
      selected: {
        background: gradients.orange,
        color: colors.white
      }
    }
  },
  button: {
    hover: {
      background: colors.greys[90]
    }
  },
  subMenuLine: colors.greys[80],
  tooltip: {
    background: colors.greys[70]
  }
};